import React from 'react'

export default function Heroes() {
    
  return (
    <section className="Banner" >
        <div className="intro py-auto"  style={{ paddingTop:"170px", textShadow:"0px 4px 4px rgba(0, 0, 0, 0.25)" }}>
          <div className="text-center text-white pt-5 " >
            <h1 className="pb-4 fw-bold pt-5">Connect on DumbSound</h1>
            <h3 className="fw-lighter">
              Discovery, Stream, and share a constantly expanding mix of music{" "}
              <br></br>
              from emerging and major artists around the world
            </h3>
          </div>
      </div>
    </section>
    
  )
}
